export default __webpack_public_path__ + "static/media/arrow-left-down.ccf709ff.svg";